import {
  communicationDocumentFilter,
  contractsDocumentFilter,
  dispositionsDocumentFilter,
  expiredDocumentsFilter,
  informationOfferFilter,
} from './document-repository-papyrus-filters';

export enum UnreadCountItemIndex {
  Offers = 0,
  Communications = 1,
  Contracts = 2,
  Dispositions = 3,
  ExpiredDocuments = 4,
}

export const unreadCountFiltersList = [
  informationOfferFilter,
  communicationDocumentFilter,
  contractsDocumentFilter,      
  dispositionsDocumentFilter,   
  expiredDocumentsFilter,      
];